// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mIw1A","top":"styles_top__2fkWJ"};